import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "loadingio-spinner-magnify-7szpfpoeeel" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "ldio-zbup4cmx5u" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("div"),
      /*#__PURE__*/_createElementVNode("div")
    ])
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}